import React, { Component } from "react";
import { Form, Modal, Input, Radio, Select, Checkbox, DatePicker, notification, Popover } from "antd";
import { speechService, speechTextService } from '../../../utils/rxjs-sharing';
import {
    CONCEPTION_OPTIONS,
    PREGNANCY_OPTIONS,
    DELIVERY_OPTIONS,
    OUTCOME_OPTIONS,
    PLACE_OF_DELIVERY_OPTIONS,
} from "../../../utils/constant";

import { Link } from "react-router-dom";
import moment from "moment";

const { Option } = Select;

class MultiplePregnancies extends Component {
  constructor(props) {
    super(props);
    this.MultiplePregnancyFormRef = React.createRef();
    this.state = {
      allowEdit: props.allowEdit,
      gender_options: [
          { val: '1', label: 'Male' },
          { val: '2', label: 'Female' },
          { val: '3', label: 'Transgender' }
      ],
      conception_options: CONCEPTION_OPTIONS,
      pregnancy_options: PREGNANCY_OPTIONS,
      delivery_options: DELIVERY_OPTIONS,
      outcome_options: OUTCOME_OPTIONS,
      place_of_delivery_options: PLACE_OF_DELIVERY_OPTIONS,
    }
  }

  async componentDidMount() {
    if(this.props.multiple_pregnancies.length > 0)
    {
      await this.setState({
        no_of_fetus : this.props.multiple_pregnancies.length,
        multiple_pregnancies : this.props.multiple_pregnancies,
      })

      await this.MultiplePregnancyFormRef.current.setFieldsValue({
        no_of_fetus: this.state.no_of_fetus,
        multiple_pregnancies : this.props.multiple_pregnancies,
      });
    }
    else
    {
      await this.setState({
        no_of_fetus : 2,
        multiple_pregnancies : [
          { delivery_type : null, delivery_place : null, delivery_outcome : null, delivery_bith_date_time : null, delivery_gender : null, delivery_birth_weight : null, delivery_birth_height : null, delivery_birth_head_cc : null, delivery_congenital_abnormality : false, delivery_congenital_abnormality_remarks : null },
          { delivery_type : null, delivery_place : null, delivery_outcome : null, delivery_bith_date_time : null, delivery_gender : null, delivery_birth_weight : null, delivery_birth_height : null, delivery_birth_head_cc : null, delivery_congenital_abnormality : false, delivery_congenital_abnormality_remarks : null }
        ],
      })

      await this.MultiplePregnancyFormRef.current.setFieldsValue({
        no_of_fetus: this.state.no_of_fetus,
        multiple_pregnancies : [
          { delivery_type : null, delivery_place : null, delivery_outcome : null, delivery_bith_date_time : null, delivery_gender : null, delivery_birth_weight : null, delivery_birth_height : null, delivery_birth_head_cc : null, delivery_congenital_abnormality : false, delivery_congenital_abnormality_remarks : null },
          { delivery_type : null, delivery_place : null, delivery_outcome : null, delivery_bith_date_time : null, delivery_gender : null, delivery_birth_weight : null, delivery_birth_height : null, delivery_birth_head_cc : null, delivery_congenital_abnormality : false, delivery_congenital_abnormality_remarks : null }
        ],
      });
    }
    
  }

  handleFetusChange = async (no_of_fetus) => {
    var new_length = no_of_fetus;
    if(no_of_fetus < 1 || no_of_fetus > 9)
    {
      return false;
    }
    if(no_of_fetus > 1)
    {
      let prev_length = this.state.multiple_pregnancies.length;
      if (new_length > prev_length) {
        let adds = new_length - prev_length;
        for (let i = 0; i < adds; i++) {
          const obj = { delivery_type : null, delivery_place : null, delivery_outcome : null, delivery_bith_date_time : null, delivery_gender : null, delivery_birth_weight : null, delivery_birth_height : null, delivery_birth_head_cc : null, delivery_congenital_abnormality : false, delivery_congenital_abnormality_remarks : null };
          await this.setState(prevState => {
            const newItems = [...prevState.multiple_pregnancies, obj];
            return { multiple_pregnancies: newItems };
          });
        }
      } else if (prev_length > new_length) {
        let removes = prev_length - new_length;
        let index = prev_length - 1;
        for (let i = 0; i < removes; i++) {
          let prevValues = await this.MultiplePregnancyFormRef.current.getFieldsValue();
          await this.setState(prevState => ({
            multiple_pregnancies: prevState.multiple_pregnancies.filter((data, j) => j !== index)
          }));
          // await prevValues['blood_bag_master'].splice(index, 1);
          await this.MultiplePregnancyFormRef.current.setFieldsValue({
            ...prevValues
          })
          index--;
        }
      }
    }
    await this.setState({
      no_of_fetus: no_of_fetus,
    })
  }

  handleFetusParamsSelectChange = async (value, props, field, index) => {
    await this.setState(prevState => {
      const prevItems = [...prevState.multiple_pregnancies];
      prevItems[index][field] = (field == "delivery_bith_date_time") ? moment(props).format('YYYY-MM-DD HH:mm:ss') : value;
      return { multiple_pregnancies: prevItems };
    });
  }

  handleChangeMultiple = async (event, field, index) => {
    await this.setState(prevState => {
      const prevItems = [...prevState.multiple_pregnancies];
      prevItems[index][field] = event.target?.value;
      return { multiple_pregnancies: prevItems };
    });
  }

  onSelectCheckChangeListMultiple = async (e, field, index) => {
    await this.setState(prevState => {
      const prevItems = [...prevState.multiple_pregnancies];
      prevItems[index][field] = e.target.checked;
      return { multiple_pregnancies: prevItems };
    })
    if(e.target.checked == false)
    {
      await this.setState(prevState => {
        const prevItems = [...prevState.multiple_pregnancies];
        prevItems[index]['delivery_congenital_abnormality_remarks'] = null;
        return { multiple_pregnancies: prevItems };
      })
    }
  }

  validateNumber = (rule, value, callback) => {
    const isValidInput = /^(\d{1,2}(\.\d{0,2})?)?$/.test(value) && parseFloat(value) <= 100;

    if (isValidInput || value === '') {
        callback();
    } else {
        callback('Only allowed (maximum 100 and upto two decimals).');
    }
  };

  normalizeValue = (value) => {        
    return value === "" || value === undefined ? "" : +value
  }

  handleFormSubmit = async (values) => {
    this.props.handleModalSave(values);
  }

  render() {
    const { multiple_pregnancies } = this.state;
    return (
      <Form
        ref={this.MultiplePregnancyFormRef}
        onFinish={this.handleFormSubmit}
        layout="vertical">
        <div className="row">
          <div className="col-2">
            <div className="form-group pl-0 hasdata">
              <input type="text" id="pregnancy-type-2" value="Multiple" disabled className="form-control" placeholder="Pregnancy Type" />
              <label htmlFor="pregnancy-type-2">Pregnancy Type</label>
            </div>
          </div>
          <div className="col-2">
            <div className="form-group">
              <div className={this.state.no_of_fetus ? 'antInputItem hasdata' : 'antInputItem'} >
                <Form.Item
                  label="No. of Fetus"
                  name="no_of_fetus"
                  rules={[
                      { required: true, message: 'Please fill No. Of Fetus.' },
                      { pattern: /^[2-9]{1,1}$/, message: 'Not allowed!' },
                      /* {max: 8, message: 'Max 8 chars.'} */
                  ]}
                >
                  <Input
                    id="no_of_fetus"
                    name="no_of_fetus"
                    disabled={!this.state.allowEdit}
                    onChange={(e) => this.handleFetusChange(e.target.value)}
                    className="onlynumbers"
                    value={this.state.no_of_fetus}
                    defaultValue={this.state.no_of_fetus}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </div>

        {(!multiple_pregnancies || multiple_pregnancies.length === 0) ? null :
          <Form.List name="multiple_pregnancies">
            {() => (
              multiple_pregnancies.map((data, key) => (
                <div key={key} className="row">
                  <div className="col-3">
                    <div className={data.delivery_type ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item
                        label="Delivery"
                        name={[key, 'delivery_type']}
                        rules={[
                            {
                                required: data.outcome == "1" || data.outcome == "2",
                                message: "Select Delivery Type",
                            },
                        ]}
                      >
                        <Select
                            style={{ width: 100 + '%' }}
                            showSearch
                            name={[key, 'delivery_type']}
                            id={[key, 'delivery_type']}
                            disabled={!this.state.allowEdit}
                            value={data.delivery_type}
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                return option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                            }}
                            onChange={(val, props) => this.handleFetusParamsSelectChange(val, props, 'delivery_type', key)}
                        >
                          {this.state.delivery_options !== undefined && this.state.delivery_options.length > 0 ? this.state.delivery_options.map((d, i) => (
                              <Option key={i} value={d.val} label={d.label}>{d.label}</Option>
                          )) : null}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_place ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item
                        label="Place"
                        name={[key, 'delivery_place']}
                        id={[key, 'delivery_place']}
                        disabled={!this.state.allowEdit}
                        value={data.delivery_place}
                        rules={[
                            {
                                required: data.delivery_outcome == "1" || data.delivery_outcome == "2",
                                message: "Select Place",
                            },
                        ]}
                      >
                        <Select
                            style={{ width: '100%' }}
                            name={[key, 'delivery_place']}
                            onChange={(val, props) => this.handleFetusParamsSelectChange(val, props, 'delivery_place', key)}
                        >
                          <Option value="1">
                              Hospital
                          </Option>
                          <Option value="2">
                              Home
                          </Option>
                          <Option value="3">
                              PHC
                          </Option>
                          <Option value="4">
                              Others
                          </Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_outcome ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item
                        label="Outcome"
                        name={[key, 'delivery_outcome']}
                        id={[key, 'delivery_outcome']}
                        rules={[
                            {
                                required: true,
                                message: "Select Outcome",
                            },
                        ]}
                      >
                        <Select
                          style={{ width: '100%' }}
                          name={[key, 'delivery_outcome']}
                          disabled={!this.state.allowEdit}
                          value={data.delivery_outcome}
                          onChange={(val, props) => this.handleFetusParamsSelectChange(val, props, 'delivery_outcome', key)}
                        >
                          <Option value="1">
                              Live Term
                          </Option>
                          <Option value="2">
                              Live Pre-Term
                          </Option>
                          <Option value="3">
                              Still born Term
                          </Option>
                          <Option value="4">
                              Still born Pre-Term
                          </Option>
                          <Option value="5">
                              Spontaneous Abortion
                          </Option>
                          <Option value="6">
                              MTP
                          </Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_bith_date_time ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item
                        name={[key, 'delivery_bith_date_time']}
                        className='mb-0'
                        label="Birth Date & Time"
                        rules={[
                            {
                                required: data.delivery_outcome == "1" || data.delivery_outcome == "2",
                                message: "Birth Date & Time is Required",
                            },
                        ]}
                      >
                        <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }}
                          name={[key, 'delivery_bith_date_time']}
                          format="DD MMM, YYYY hh:mm A"
                          disabledDate={this.disabledPastDate}
                          value={data.delivery_bith_date_time}
                          defaultValue={data.delivery_bith_date_time}
                          placeholder=''
                          className='mb-0'
                          style={{
                              width: 100 + "%",
                              height: 41 + "px",
                          }}
                          onChange={(val, props) => this.handleFetusParamsSelectChange(val, props, 'delivery_bith_date_time', key)}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_gender ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item
                        label="Gender"
                        name={[key, 'delivery_gender']}
                        rules={[
                            {
                                required: data.delivery_outcome == "1" || data.delivery_outcome == "2",
                                message: "Select Gender",
                            },
                        ]}
                      >
                        <Select
                            style={{ width: 100 + '%' }}
                            showSearch
                            name={[key, 'delivery_gender']}
                            id={[key, 'delivery_gender']}
                            optionFilterProp="children"
                            disabled={!this.state.allowEdit}
                            value={data.delivery_gender} 
                            filterOption={(input, option) => {
                                return option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                            }}
                            onChange={(val, props) => this.handleFetusParamsSelectChange(val, props, 'delivery_gender', key)}
                        >
                            {this.state.gender_options !== undefined && this.state.gender_options.length > 0 ? this.state.gender_options.map((d, i) => (
                                <Option key={i} value={d.val} label={d.label}>{d.label}</Option>
                            )) : null}

                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_birth_weight ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item name={[key, 'delivery_birth_weight']} label="Birth Weight (kg)" id={[key, 'delivery_birth_weight']}
                        rules={[
                          {
                            required: data.delivery_outcome == "1" || data.delivery_outcome == "2",
                            message: "Birth Weight is Required",
                          },
                          {
                            validator: this.validateNumber,
                            transform: this.normalizeValue
                          }
                        ]}
                      >
                        <Input className=""
                          onChange={(e) => this.handleChangeMultiple(e, 'delivery_birth_weight', key)}
                          name="delivery_birth_weight"
                          disabled={!this.state.allowEdit}
                          type='number'
                          value={data.delivery_birth_weight} 
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_birth_height ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item name={[key, 'delivery_birth_height']} label="Birth Height (cm)" id={[key, 'delivery_birth_height']}
                        rules={[
                          {
                            required: data.delivery_outcome == "1" || data.delivery_outcome == "2",
                            message: "Birth Height is Required",
                          },
                          {
                            validator: this.validateNumber,
                            transform: this.normalizeValue
                          }
                        ]}
                      >
                        <Input className=""
                          onChange={(e) => this.handleChangeMultiple(e, 'delivery_birth_height', key)}
                          name="delivery_birth_height"
                          disabled={!this.state.allowEdit}
                          type='number'
                          value={data.delivery_birth_height} 
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className='col-3'>
                    <div className={data.delivery_birth_head_cc ? 'antSelectItem hasdata' : 'antSelectItem'}>
                      <Form.Item name={[key, 'delivery_birth_head_cc']} label="Birth Head CC (cm)" id={[key, 'delivery_birth_head_cc']}
                        rules={[
                          {
                            required: data.delivery_outcome == "1" || data.delivery_outcome == "2",
                            message: "Birth Head CC is Required",
                          },
                          {
                            validator: this.validateNumber,
                            transform: this.normalizeValue
                          }
                        ]}
                      >
                        <Input className=""
                          onChange={(e) => this.handleChangeMultiple(e, 'delivery_birth_head_cc', key)}
                          name="delivery_birth_head_cc"
                          disabled={!this.state.allowEdit}
                          type='number'
                          value={data.delivery_birth_head_cc} 
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-3">
                    <Form.Item
                      name={[key, 'delivery_congenital_abnormality']}
                      valuePropName="checked"
                    >
                      <Checkbox
                        name={[key, 'delivery_congenital_abnormality']}
                        disabled={!this.state.allowEdit}
                        checked={data.delivery_congenital_abnormality === true}
                        onChange={(e) => this.onSelectCheckChangeListMultiple(e, 'delivery_congenital_abnormality', key)}
                      >
                        Congenital Abnormality
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {
                    data.delivery_congenital_abnormality == true 
                    ?
                      <div className="col-9">
                          <div className="form-group">
                              <div className='antInputItem micwrap hasdata' >
                                  <Form.Item
                                    name={[key, 'delivery_congenital_abnormality_remarks']}
                                    label="Congenital Abnormality Remark"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Congenital Abnormality Remark Required",
                                        },
                                    ]}
                                  >
                                    <textarea className="form-control diagnosis_notes_class speech-field" value={data.delivery_congenital_abnormality_remarks}
                                      name={[key, 'delivery_congenital_abnormality_remarks']}
                                      onChange={(e) => this.handleChangeMultiple(e, 'delivery_congenital_abnormality_remarks', key)}
                                      disabled={!this.state.allowEdit}
                                    />
                                  </Form.Item>
                              </div>
                          </div>
                      </div>
                    : 
                    null
                  }
                </div>
              ))
            )}
          </Form.List>
        }
        <div className="ant-col-24 mt-3 mb-2 text-center">
          <button
            type="submit"
            className="btn btn-primary text-uppercase px-5"
            data-target=""
          >
            Save
          </button>
        </div>
      </Form>
    )
  }
}

export default MultiplePregnancies;